export default {
  //   商品管理
  // 商品列表
  goods_list_add: "GoodsAdd",
  goods_list_edit: "GoodsEdit",
  goods_list_del: "goods_list_del",
  goods_list_status: "goods_list_status",
  goods_list_home_hot: "goods_list_home_hot",
  goods_list_home_recommend: "goods_list_home_recommend",
  goods_list_weight: "goods_list_weight",
  // 商品分类
  goods_cate_add: "GoodsCategoryAdd",
  goods_cate_edit: "GoodsCategoryEdit",
  goods_cate_status: "goods_cate_status",
  goods_cate_del: "goods_cate_del",

  // 用户管理
  // 用户列表
  member_list_add_white: "member_list_add_white",
  member_list_add_black: "member_list_add_black",
  //   白名单列表
  member_white_list_add: "WhiteAdd",
  member_white_list_edit: "WhiteEdit",
  member_white_list_del: "member_white_list_del",
  member_white_list_add_black: "member_white_list_add_black",
  //   黑名单列表
  member_black_list_add_white: "member_black_list_add_white",
  member_black_list_add: "BlackAdd",
  member_black_list_edit: "BlackEdit",
  member_black_list_del: "member_black_list_del",
  // 订单备注
  member_order_remark_export: "member_order_remark_export",
  // 售后备注
  member_aftersale_remark_export: "member_aftersale_remark_export",

  //   订单管理
  // 订单列表
  order_list_export: "order_list_export",
  order_list_data_import: "order_list_data_import",
  order_list_detail: "OrderDetail",
  order_list_send: "OrderDelivery",
  order_list_cancel: "order_list_cancel",
  order_list_cancel_high: "order_list_cancel_high",
  order_list_bill: "OrderBill",
  order_list_contract: "OrderContractDetail",
  order_list_complete: "order_list_complete",
  order_list_ahead_return: "order_list_ahead_return",
  order_list_offline_pay: "order_list_offline_pay",
  order_list_delivery_detail: "order_list_delivery_detail",
  order_list_after_sale_status: "order_list_after_sale_status",
  order_list_device_status: "order_list_device_status",
  order_list_confirm_receive: "order_list_confirm_receive",
  order_list_reserve_record: "order_list_reserve_record",
  order_list_detail_store_calc: "order_list_detail_store_calc",
  order_list_detail_edit_address: "order_list_detail_edit_address",
  order_list_detail_update_kf: "order_list_detail_update_kf",
  order_list_detail_update_bd: "order_list_detail_update_bd",
  order_list_detail_update_device_sn: "order_list_detail_update_device_sn",
  order_list_detail_update_delivery_receipt: "order_list_detail_update_delivery_receipt",
  // 订单管理-- 账单列表
  order_bill_list_export: "order_bill_list_export",
  order_bill_expired_today_export: "order_bill_expired_today_export",

  //   网销订单
  // 订单列表
  order_mall_list_export: "order_mall_list_export",
  order_mall_list_detail: "OrderDetail",
  order_mall_list_send: "OrderDelivery",
  order_mall_list_cancel: "order_mall_list_cancel",
  order_mall_list_cancel_high: "order_mall_list_cancel_high",
  order_mall_list_bill: "OrderBill",
  order_mall_list_contract: "OrderContractDetail",
  order_mall_list_complete: "order_mall_list_complete",
  order_mall_list_ahead_return: "order_mall_list_ahead_return",
  order_mall_list_offline_pay: "order_mall_list_offline_pay",
  order_mall_list_after_sale_status: "order_mall_list_after_sale_status",

  //   财务管理
  // 财务流水
  finance_bill_list_add: "FinanceBillAdd",
  finance_bill_list_export: "finance_bill_list_export",
  finance_bill_list_edit_amount: "finance_bill_list_edit_amount",
  // 账单管理
  finance_order_list_export: "finance_order_list_export",
  finance_order_list_edit_repay: "finance_order_list_edit_repay",
  finance_order_list_edit_amount: "finance_order_list_edit_amount",
  finance_order_list_offline_pay: "finance_order_list_offline_pay",
  finance_order_list_device_lock: "finance_order_list_device_lock",
  finance_order_list_handle_more: "finance_order_list_handle_more",
  finance_order_list_order_reserve: "finance_order_list_order_reserve",
  // 订单挂账
  finance_reserve_list_add: "finance_reserve_list_add",
  finance_reserve_list_export: "finance_reserve_list_export",
  // 门店结算管理
  finance_store_settle_export: "finance_store_settle_export",
  finance_store_settle_alipay_payment: "finance_store_settle_alipay_payment",
  finance_store_settle_alipay_revoke: "finance_store_settle_alipay_revoke",
  finance_store_settle_offline_payment: "finance_store_settle_offline_payment",
  finance_store_settle_receipt_download: "finance_store_settle_receipt_download",

  //   审核管理
  // 审核列表
  review_list_draw: "review_list_draw",
  review_list_draw_cancel: "review_list_draw_cancel",
  review_list_detail: "ReviewOrderDetail",
  review_list_detail_edit_address: "review_list_detail_edit_address",
  review_list_detail_edit_price_rate: "review_list_detail_edit_price_rate",
  review_list_detail_edit_cost_price: "review_list_detail_edit_cost_price",
  review_list_detail_edit_final_grade: "review_list_detail_edit_final_grade",
  // 审核明细
  review_assign_list_export: "review_assign_list_export",
  review_assign_list_remark: "review_assign_list_remark",
  // 规则配置
  review_rule_add: "ReviewRuleAdd",
  review_rule_edit: "ReviewRuleEdit",
  review_rule_detail: "ReviewRuleDetail",
  review_rule_status: "review_rule_status",
  review_rule_del: "review_rule_del",

  //  门店管理
  // 门店列表
  store_list_add: "StoreAdd",
  store_list_edit: "StoreEdit",
  store_list_detail: "store_list_detail",
  store_list_export: "store_list_export",
  store_list_del: "store_list_del",
  store_list_copy_link: "store_list_copy_link",
  store_list_material: "store_list_material",
  store_list_alipay_material: "store_list_alipay_material",
  store_list_status: "store_list_status",
  store_list_wap_status: "store_list_wap_status",
  store_list_grade_config: "store_list_grade_config",
  store_list_combo_config: "store_list_combo_config",
  // 门店商品
  store_goods1_list_export: "store_goods1_list_export",
  store_goods1_list_import: "store_goods1_list_import",
  store_goods1_list_add: "StoreGoods1Add",
  store_goods1_list_edit: "StoreGoods1Edit",
  store_goods1_list_del: "store_goods1_list_del",
  store_goods1_list_recycle_price_edit: "store_goods1_list_recycle_price_edit",
  store_goods1_list_status: "store_goods1_list_status",
  store_goods2_list_export: "store_goods2_list_export",
  store_goods2_list_import: "store_goods2_list_import",
  store_goods2_list_add: "StoreGoods2Add",
  store_goods2_ist_edit: "StoreGoods2Edit",
  store_goods2_list_del: "store_goods2_list_del",
  store_goods2_list_status: "store_goods2_list_status",
  // 门店方案
  store_combo_create: "store_combo_create",
  store_combo_view: "store_combo_view",
  store_combo_edit: "store_combo_edit",
  store_combo_delete: "store_combo_delete",
  store_combo_status_edit: "store_combo_status_edit",
  // 商品属性管理
  store_goods_attr_create: "store_goods_attr_create",
  store_goods_attr_edit: "store_goods_attr_edit",

  //   商户管理
  // 商户列表
  merchant_list_add: "MerchantAdd",
  merchant_list_edit: "MerchantEdit",
  merchant_list_del: "merchant_list_del",
  merchant_list_status: "merchant_list_status",

  // 资方管理
  // 资方列表
  capital_list_export: "capital_list_export",
  capital_list_add: "capital_list_add",
  capital_list_edit: "capital_list_edit",
  capital_list_recharge: "capital_list_recharge",
  capital_list_status: "capital_list_status",
  // 动账明细
  capital_bill_list_export: "capital_bill_list_export",
  capital_bill_list_add: "capital_bill_list_add",
  // 订单列表
  capital_order_list_export: "capital_order_list_export",
  capital_order_list_detail: "OrderDetail",
  capital_order_list_bill: "OrderBill",
  // 资方提现
  capital_withdraw_list_export: "capital_withdraw_list_export",
  capital_withdraw_list_review: "capital_withdraw_list_review",

  //   运营管理
  // 广告设置
  operation_ad_add: 'operation_ad_add',
  operation_ad_edit: 'operation_ad_edit',
  operation_ad_link_config: 'operation_ad_link_config',
  operation_ad_del: 'operation_ad_del',
  operation_ad_status: 'operation_ad_status',
  // 运营文案
  operation_lease_submit: "operation_lease_submit",
  // 协议合同
  operation_contract_submit: "operation_contract_submit",
  // 商品品牌管理
  operation_goods_brand_create: "operation_goods_brand_create",
  operation_goods_brand_edit: "operation_goods_brand_edit",
  operation_goods_brand_delete: "operation_goods_brand_delete",

  //   系统设置
  // 字典管理
  dict_list_add: "DictAddOrEdit",
  dict_list_edit: "DictAddOrEdit",
  dict_list_del: "dict_list_del",
  dict_list_redirect_value: "DictValueList",
  dict_value_list_add: "DictValueAddOrEdit",
  dict_value_list_edit: "DictValueAddOrEdit",

  //   权限管理
  // 管理员
  user_list_add: "UserAdd",
  user_list_edit: "UserEdit",
  user_list_del: "user_list_del",
  user_list_status: "user_list_status",
  //   角色
  role_list_add: "RoleAdd",
  role_list_edit: "RoleEdit",
  role_list_del: "role_list_del",
  role_list_menu: "role_list_menu",
  //   菜单
  menu_list_add: "MenuAdd",
  menu_list_edit: "MenuEdit",
  menu_list_del: "menu_list_del",
  //   部门
  dept_list_add: "dept_list_add",
  dept_list_edit: "dept_list_edit",
  dept_list_del: "dept_list_del",
};
